import { Tag } from 'antd'

import { SpecimenStatus } from 'src/api/requests'
import { useLocales } from 'src/locales'

type Props = {
  status?: SpecimenStatus
}

const InvestigationStatusMap = {
  [SpecimenStatus.SENT_TO_LABORATORY]: 'success',
  [SpecimenStatus.COMPLETED]: 'success',
  [SpecimenStatus.CREATED]: 'processing',
  [SpecimenStatus.HARVESTED]: 'success',
  [SpecimenStatus.IN_PROGRESS]: 'warning',
  [SpecimenStatus.REJECTED]: 'error',
  [SpecimenStatus.RECEIVED]: 'success'
}
export const TestStatusTag = ({ status }: Props) => {
  const { t } = useLocales()

  const color = InvestigationStatusMap[status ?? SpecimenStatus.IN_PROGRESS]

  return <Tag color={color}>{t(`tests.statuses.${status}`)}</Tag>
}
